import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useGetCommonStore } from '@/store';

export const usePopupHeight = () => {
  const useCommonStore = useGetCommonStore();

  const { isEmailConfirmationPopup, emailConfirmationPopupHeight } =
    useCommonStore(
      useShallow((state) => ({
        isEmailConfirmationPopup: state.isEmailConfirmationPopup,
        emailConfirmationPopupHeight: state.emailConfirmationPopupHeight,
      }))
    );

  const popupHeight = useMemo(() => {
    if (isEmailConfirmationPopup) {
      return emailConfirmationPopupHeight;
    }

    return 0;
  }, [emailConfirmationPopupHeight, isEmailConfirmationPopup]);

  return { popupHeight };
};
